var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HiDatatable',{staticStyle:{"height":"100%"},attrs:{"headers":_vm.headers,"items":_vm.leads,"search-bar":"","sort-by":"dateUpdated","desc":"","search-label-type":"leads","local-id":"hive-leads-list"},on:{"select":_vm.selectRow}})}
var staticRenderFns = []

export { render, staticRenderFns }